import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;

export function usePermissions() {
  const [perms, setPerms] = useState(cache);
  useEffect(() => {
    if (cache) { setPerms(cache); return; }
    api.get("/my/permissions").then((r) => { cache = r.data; setPerms(r.data); }).catch(() => setPerms({ all: false, permissions: {} }));
  }, []);
  const can = (module, action = "view") => {
    if (!perms) return false;
    if (perms.all) return true;
    const list = perms.permissions?.[module] || [];
    return list.includes(action);
  };
  return { perms, can };
}

export function clearPermissionsCache() { cache = null; }
